import { IsNotEmpty, IsObject, IsOptional, IsPhoneNumber, IsString, IsUUID, MinLength, ValidateNested } from "class-validator";
import { EventInstanceDto } from './event.dto';
import { EventPriceDto } from "./event-price.dto";
import { DiscountDto, CreateTrackingLinkDiscountDto, DiscountToTrackingLinkDto } from "./discount.dto";
import { UserDto } from "./user.dto";
import { Type } from "class-transformer";
import { OrderDto } from "./order.dto";

export class TrackingLinksToEventsDto {
	public id: string;
	public trackingLinkId: string;
	public eventBaseId: string;
	public eventInstanceDate?: Date;

	public createdAt: Date;
	public updatedAt: Date;

	public trackingLink?: TrackingLinkDto;
	public eventInstance?: EventInstanceDto;
}

export class TrackingLinkDto {
	public id: string;
	public name: string;
	public communityId: string;
	public referralCode: string;
	public assignedUserId?: string;
	public baseDiscountId?: string;
	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public viewsCount?: number;
	public ticketsSoldCount?: number;
	public conversionPercent?: number;
	public earningsAmount?: number;

	public discountsToTrackingLinks?: DiscountToTrackingLinkDto[];
	public discount?: DiscountDto;
	public assignedUser?: UserDto;
	public trackingLinksToEvents?: TrackingLinksToEventsDto[];

	public orders?: OrderDto[];
}

export type TrackingLinkStats = Pick<TrackingLinkDto, 'earningsAmount' | 'ticketsSoldCount' | 'viewsCount' | 'conversionPercent'>;

export class CreateTrackingLinkDto {
	@IsString()
	@IsNotEmpty({ message: "Name is required" })
	public name: string;

	@IsString()
	@IsNotEmpty({ message: "Code is required" })
	@MinLength(2)
	public referralCode: string;

	@IsString()
	@IsNotEmpty()
	@IsUUID(4)
	public communityId: string;


	@IsOptional()
	@IsString()
	@IsPhoneNumber(undefined, { message: 'Phone is invalid' })
	public assignedUserByPhone?: string;
}

export class CreateTrackingLinkForEventDto extends CreateTrackingLinkDto {
	@IsString()
	@IsNotEmpty({ message: "Event base id is required" })
	public eventBaseId: string;

	@IsOptional()
	public eventInstanceDate?: Date;

	@IsOptional()
	@Type(() => CreateTrackingLinkDiscountDto)
	@ValidateNested()
	public createDiscount?: CreateTrackingLinkDiscountDto;
}
